exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":root{--color-brand:#2359a8}.popup .submit-event{margin-top:1em;padding:1em}@media (min-width:42rem){.popup .submit-event{margin-top:unset;position:absolute;top:3.6em;width:730px;height:395px;z-index:99;background:hsla(0,0%,100%,.95);padding:2em 2em 0;right:1.5em}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5deb7426","scoped":false,"hasInlineConfig":false}!./node_modules/less-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./theme/_base/vue/SubmitEvent.vue
// module id = 144
// module chunks = 0 1